import * as yup from "yup";
import { CantidadSchema } from "./CantidadSchema";

export const FuenteEfluenteLiquidoSchema = yup.object().shape({
  orden: yup.number().required("errors.fuenteEfluenteLiquido.orden.required"),
  nombre: yup
    .string()
    .max(100, "errors.fuenteEfluenteLiquido.nombre.max")
    .required("errors.fuenteEfluenteLiquido.nombre.required")
    .default(""),
  operacionesUnitarias: yup
    .array()
    .min(1, "errors.fuenteEfluenteLiquido.operacionesUnitarias.min")
    .required("errors.fuenteEfluenteLiquido.operacionUnitarias.required")
    .default([]),
  caudalMedio: CantidadSchema.required(
    "errors.fuenteEfluenteLiquido.caudalMedio.required",
  )
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .default({ magnitud: 0, unidad: { codigo: "M3DIA" } }),
  destino: yup
    .string()
    .required("errors.fuenteEfluenteLiquido.destino.required")
    .max(1024, "errors.fuenteEfluenteLiquido.destino.max")
    .default(null),
});
